import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { Card } from '../components/ui/Card';
import { TrendingUpIcon, WalletIcon, ArrowUpIcon, ArrowDownIcon, BarChart3Icon } from 'lucide-react';
export function Dashboard() {
  return <div data-id="element-311">
      <PageHeader title="Dashboard" description="Welcome to your Oxy Pay dashboard" data-id="element-312" />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-313">
        <StatCard title="Total Balance" value="$12,560.00" change="+2.5%" isPositive={true} icon={<WalletIcon className="h-6 w-6 text-blue-500" data-id="element-315" />} data-id="element-314" />
        <StatCard title="Crypto Assets" value="$4,200.00" change="+5.2%" isPositive={true} icon={<TrendingUpIcon className="h-6 w-6 text-green-500" data-id="element-317" />} data-id="element-316" />
        <StatCard title="Gift Cards" value="$850.00" change="-1.4%" isPositive={false} icon={<BarChart3Icon className="h-6 w-6 text-purple-500" data-id="element-319" />} data-id="element-318" />
        <StatCard title="Savings" value="$3,280.00" change="+3.1%" isPositive={true} icon={<TrendingUpIcon className="h-6 w-6 text-blue-500" data-id="element-321" />} data-id="element-320" />
      </div>
      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2" data-id="element-322">
        <Card title="Recent Transactions" data-id="element-323">
          <div className="space-y-4" data-id="element-324">
            {[{
            name: 'Crypto Purchase',
            amount: '+$250.00',
            date: 'Today',
            type: 'crypto'
          }, {
            name: 'Bill Payment',
            amount: '-$120.00',
            date: 'Yesterday',
            type: 'bill'
          }, {
            name: 'Gift Card Sale',
            amount: '+$50.00',
            date: 'Jul 12',
            type: 'gift'
          }, {
            name: 'Savings Deposit',
            amount: '+$300.00',
            date: 'Jul 10',
            type: 'savings'
          }].map((transaction, i) => <div key={i} className="flex justify-between items-center" data-id="element-325">
                <div className="flex items-center" data-id="element-326">
                  <div className={`p-2 rounded-full ${transaction.type === 'crypto' ? 'bg-blue-100' : transaction.type === 'bill' ? 'bg-red-100' : transaction.type === 'gift' ? 'bg-purple-100' : 'bg-green-100'}`} data-id="element-327">
                    {transaction.type === 'crypto' ? <TrendingUpIcon className="h-5 w-5 text-blue-600" data-id="element-328" /> : transaction.type === 'bill' ? <ArrowDownIcon className="h-5 w-5 text-red-600" data-id="element-329" /> : transaction.type === 'gift' ? <ArrowUpIcon className="h-5 w-5 text-purple-600" data-id="element-330" /> : <ArrowUpIcon className="h-5 w-5 text-green-600" data-id="element-331" />}
                  </div>
                  <div className="ml-4" data-id="element-332">
                    <p className="text-sm font-medium text-gray-900" data-id="element-333">
                      {transaction.name}
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-334">{transaction.date}</p>
                  </div>
                </div>
                <span className={`text-sm font-medium ${transaction.amount.startsWith('+') ? 'text-green-600' : 'text-red-600'}`} data-id="element-335">
                  {transaction.amount}
                </span>
              </div>)}
          </div>
        </Card>
        <Card title="Quick Actions" data-id="element-336">
          <div className="grid grid-cols-2 gap-4" data-id="element-337">
            <ActionButton label="Send Crypto" icon={<ArrowUpIcon className="h-5 w-5" data-id="element-339" />} to="/crypto" data-id="element-338" />
            <ActionButton label="Sell Gift Card" icon={<WalletIcon className="h-5 w-5" data-id="element-341" />} to="/gift-cards" data-id="element-340" />
            <ActionButton label="Pay Bills" icon={<ArrowDownIcon className="h-5 w-5" data-id="element-343" />} to="/bill-payment" data-id="element-342" />
            <ActionButton label="Generate NIN" icon={<TrendingUpIcon className="h-5 w-5" data-id="element-345" />} to="/nin-printing" data-id="element-344" />
          </div>
        </Card>
      </div>
    </div>;
}
interface StatCardProps {
  title: string;
  value: string;
  change: string;
  isPositive: boolean;
  icon: React.ReactNode;
}
function StatCard({
  title,
  value,
  change,
  isPositive,
  icon
}: StatCardProps) {
  return <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-346">
      <div className="p-5" data-id="element-347">
        <div className="flex items-center" data-id="element-348">
          <div className="flex-shrink-0" data-id="element-349">{icon}</div>
          <div className="ml-5 w-0 flex-1" data-id="element-350">
            <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-351">
              {title}
            </dt>
            <dd className="flex items-baseline" data-id="element-352">
              <div className="text-2xl font-semibold text-gray-900" data-id="element-353">
                {value}
              </div>
              <div className={`ml-2 flex items-baseline text-sm font-semibold ${isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-354">
                {isPositive ? <ArrowUpIcon className="self-center flex-shrink-0 h-4 w-4 text-green-500" aria-hidden="true" data-id="element-355" /> : <ArrowDownIcon className="self-center flex-shrink-0 h-4 w-4 text-red-500" aria-hidden="true" data-id="element-356" />}
                <span className="ml-1" data-id="element-357">{change}</span>
              </div>
            </dd>
          </div>
        </div>
      </div>
    </div>;
}
function ActionButton({
  label,
  icon,
  to
}: {
  label: string;
  icon: React.ReactNode;
  to: string;
}) {
  return <a href={to} className="flex items-center p-3 text-base font-medium text-gray-900 rounded-lg bg-gray-50 hover:bg-gray-100" data-id="element-358">
      <div className="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-blue-500 text-white" data-id="element-359">
        {icon}
      </div>
      <div className="ml-3 text-sm" data-id="element-360">{label}</div>
    </a>;
}